"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePullRefreshV2 = exports.usePullRefresh = exports.insetItemIfNeed = exports.removeItem = void 0;
const common_business_1 = require("@pionex-web-kit/common-business");
const react_1 = require("react");
const operators_1 = require("rxjs/operators");
/**移除removeIndex指定的元素，并返回新的数组 */
function removeItem(source, removeIndex) {
    // shadow clone
    const newSource = source.slice(0);
    if (removeIndex !== -1) {
        newSource.splice(removeIndex, 1);
        return newSource;
    }
    return source;
}
exports.removeItem = removeItem;
/**执行willInsert函数，并且返回新的数据列表 */
function insetItemIfNeed(source, willInsert, insertItem) {
    if (willInsert(source === null || source === void 0 ? void 0 : source[0])) {
        // shadow clone
        const newSource = source.slice(0);
        newSource.unshift(Object.assign({}, insertItem));
        return newSource;
    }
    return source;
}
exports.insetItemIfNeed = insetItemIfNeed;
const defaultList = [];
/**通用的适配下拉刷新逻辑的hooks */
/**@deprecated 已废弃，请使用usePullRefreshV2 */
function usePullRefresh(props) {
    const { query, filterParams, getLoadMoreParams, pageLimit, accountType, onProcessData, active } = props;
    const [listData, setListData] = (0, react_1.useState)([]);
    const [error, setError] = (0, react_1.useState)();
    const [refreshing, setRefreshing] = (0, react_1.useState)(true);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [hasMore, setHasMore] = (0, react_1.useState)(true);
    const initSuccess = (0, react_1.useRef)(false);
    const loadingRef = (0, react_1.useRef)(false);
    /**获取加载下一页数据时的额外参数 */
    const extraParams = (0, react_1.useMemo)(() => getLoadMoreParams === null || getLoadMoreParams === void 0 ? void 0 : getLoadMoreParams(listData), [listData, getLoadMoreParams]);
    const processFunRef = (0, react_1.useRef)(onProcessData);
    processFunRef.current = onProcessData;
    const queryData = (0, react_1.useCallback)((loadMoreParams, indexOffset = 0) => {
        const processData = processFunRef.current;
        const sub = query(Object.assign({}, filterParams, loadMoreParams, { limit: pageLimit, accountType }));
        if (processData) {
            return sub.pipe((0, operators_1.map)((source) => processData(source, indexOffset)));
        }
        return sub;
    }, [accountType, filterParams, pageLimit, query]);
    const queryRef = (0, react_1.useRef)(queryData);
    queryRef.current = queryData;
    const refresh = (0, react_1.useCallback)(() => {
        if (loadingRef.current) {
            return;
        }
        setRefreshing(true);
        loadingRef.current = true;
        return queryRef.current().subscribe({
            next: (data) => {
                const newData = data || [];
                setRefreshing(false);
                setError(null);
                setHasMore(newData.length >= pageLimit);
                setListData(newData);
                loadingRef.current = false;
                initSuccess.current = true;
            },
            error: (error) => {
                setRefreshing(false);
                setError(error);
                setHasMore(false);
                loadingRef.current = false;
            },
        });
    }, [pageLimit]);
    const loadMore = (0, react_1.useCallback)(() => {
        if (!extraParams || !hasMore || !listData.length || loadingRef.current) {
            return;
        }
        loadingRef.current = true;
        setLoading(true);
        return queryRef.current(extraParams, listData.length).subscribe({
            next: (data) => {
                setError(null);
                const newData = data || [];
                setHasMore(newData.length >= pageLimit);
                setListData((prevData) => {
                    return prevData.concat(newData);
                });
                loadingRef.current = false;
                setLoading(false);
            },
            error: (error) => {
                setHasMore(false);
                loadingRef.current = false;
                setLoading(false);
            },
        });
    }, [extraParams, hasMore, listData.length, pageLimit]);
    /**当筛选参数发生改变时，重新获取最新的数据 */
    (0, react_1.useEffect)(() => {
        if (initSuccess.current && !active) {
            return;
        }
        const sub = refresh();
        return () => {
            // 重置下相关的状态
            setLoading(false);
            setRefreshing(false);
            loadingRef.current = false;
            setError(null);
            sub === null || sub === void 0 ? void 0 : sub.unsubscribe();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterParams, active]);
    return { refresh, loadMore, error, refreshing, loading, hasMore, listData, setListData };
}
exports.usePullRefresh = usePullRefresh;
function usePullRefreshV2({ query, active, }) {
    const [result, setResult] = (0, react_1.useState)();
    const hasMore = (0, react_1.useMemo)(() => !result || !!result.hasMore, [result]);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [refreshing, setRefreshing] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)();
    const initSuccess = (0, react_1.useRef)(false);
    const queryFn = (0, common_business_1.usePersistFn)((reset) => {
        return query(reset ? {} : (result === null || result === void 0 ? void 0 : result.params) || {});
    });
    const loadMore = (0, common_business_1.usePersistFn)(() => {
        if (!hasMore || loading || refreshing) {
            return;
        }
        setLoading(true);
        return queryFn().subscribe({
            next: (nData) => {
                setError(null);
                setResult((pResult) => {
                    const { data = [] } = pResult || {};
                    return {
                        params: nData.params,
                        hasMore: nData.hasMore,
                        data: data.concat(nData.data || []),
                    };
                });
                setLoading(false);
            },
            error: (error) => {
                setLoading(false);
            },
        });
    });
    const refresh = (0, common_business_1.usePersistFn)(() => {
        if (loading) {
            return;
        }
        setRefreshing(true);
        return queryFn(true).subscribe({
            next: (nData) => {
                setError(null);
                setResult(nData);
                setRefreshing(false);
                initSuccess.current = true;
            },
            error: (error) => {
                setError(error);
                setRefreshing(false);
            },
        });
    });
    /**当筛选参数发生改变时，重新获取最新的数据 */
    (0, react_1.useEffect)(() => {
        if (initSuccess.current && !active) {
            return;
        }
        const sub = refresh();
        return () => {
            // 重置下相关的状态
            setLoading(false);
            setRefreshing(false);
            setError(null);
            sub === null || sub === void 0 ? void 0 : sub.unsubscribe();
        };
    }, [active, refresh]);
    const setListData = (0, common_business_1.usePersistFn)((nListData) => {
        setResult((p) => {
            const nList = typeof nListData === "function" ? nListData((p === null || p === void 0 ? void 0 : p.data) || []) : nListData;
            return Object.assign(Object.assign({}, p), { data: nList });
        });
    });
    return { refresh, loadMore, error, refreshing, loading, hasMore, listData: (result === null || result === void 0 ? void 0 : result.data) || defaultList, setListData };
}
exports.usePullRefreshV2 = usePullRefreshV2;
